import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getEnv } from 'services/env-service';
import { useSelector } from 'react-redux';
import { getUserDetails } from 'store/selectors/auth';
import { EMAIL_SERVICES } from '../../../constants/common';

export default function useEmailForm() {
  const user = useSelector(getUserDetails);
  return useForm({
    defaultValues: {
      ...defaultValues,
      projectId: user.isGuest
        ? getEnv('REACT_APP_DEFAULT_EMAIL_PROJECT_ID')
        : user.projectId || -1,
    },
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });
}

const defaultValues = {
  projectId: -1,
  templateId: -1,
  authorizedAccountId: '0',
  senderName: '',
  senderEmail: '',
  force_choose: '-1',
  selectedTemplateForceChoose: null,
  scheduledTime: '',
  isMultiMode: false,
  isMicrosoft: false,
  recipients: [],
  csvFiles: [],
  shouldUseMailerMicroservice: false,
  allow_duplicates: false,
  disable_throttling: false,
  disableOpenTracking: false,
  disableClickTracking: false,
};

const schema = yup.object().shape({
  projectId: yup
    .number()
    .min(1, 'Project is required')
    .required()
    .label('Project'),
  templateId: yup
    .number()
    .label('Email template')
    .when('isMultiMode', {
      is: true,
      then: yup.number(),
      otherwise: yup
        .number()
        .min(1, 'Email template is required')
        .required(),
    }),
  senderName: yup
    .string()
    .label('Sender Name')
    .when('force_choose', {
      is: v => [EMAIL_SERVICES.GMAIL, EMAIL_SERVICES.MICROSOFT].includes(v),
      then: yup.string(),
      otherwise: yup.string().when('isMultiMode', {
        is: true,
        then: yup.string(),
        otherwise: yup.string().required(),
      }),
    }),
  senderEmail: yup
    .string()
    .label('Sender Email')
    .when('force_choose', {
      is: v => [EMAIL_SERVICES.GMAIL, EMAIL_SERVICES.MICROSOFT].includes(v),
      then: yup.string(),
      otherwise: yup.string().when('isMultiMode', {
        is: true,
        then: yup.string(),
        otherwise: yup
          .string()
          .email()
          .required(),
      }),
    }),
  authorizedAccountId: yup
    .number()
    .label('Gmail Account')
    .when(['force_choose', 'isMultiMode'], {
      is: (force_choose, isMultiMode) =>
        [EMAIL_SERVICES.GMAIL, EMAIL_SERVICES.MICROSOFT].includes(
          force_choose,
        ) && !isMultiMode,
      then: yup
        .number()
        .min(1, 'Gmail Account is required')
        .required('Gmail Account is required'),
      otherwise: yup.number(),
    }),
});
